import type { UserAccessProfile } from "@pilatestime-admin/shared-types";
import { queryOptions } from "@tanstack/react-query";
import api from "./api_client";

export const fetchAccessProfile = (token: string): Promise<UserAccessProfile> =>
	api
		.get("/auth/profile/access", {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
		.then((res) => res.data);

export const fetchAccessProfileQueryOptions = (userId: string, token: string) =>
	queryOptions({
		queryKey: ["access_profile", userId],
		queryFn: () => fetchAccessProfile(token),
		staleTime: 2 * 60 * 1000,
	});
